import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { AccountNotification } from '@smmof/entity'; // Замени на реальный путь

export const AccountNotificationsActions = createActionGroup({
  source: 'Account Notifications',
  events: {
    'Load Notifications': emptyProps(),
    'Load Notifications Success': props<{ notifications: AccountNotification[] }>(),
    'Load Notifications Failure': props<{ error: any }>(),

    'Add Notification': props<{ notification: AccountNotification }>(),
    'Add Notification Success': props<{ notification: AccountNotification }>(),
    'Add Notification Failure': props<{ error: any }>(),

    'Update Notification': props<{ notification: AccountNotification }>(),
    'Update Notification Success': props<{ notification: AccountNotification }>(),
    'Update Notification Failure': props<{ error: any }>(),

    'Delete Notification': props<{ id: string }>(),
    'Delete Notification Success': props<{ id: string }>(),
    'Delete Notification Failure': props<{ error: any }>(),

    'Mark All As Read': emptyProps(),
    'Mark All As Read Success': emptyProps(),
    'Mark All As Read Failure': props<{ error: any }>(),

    // Новые действия для WebSocket
    'Connect WebSocket': emptyProps(),
    'Receive WebSocket Notification': props<{ notification: AccountNotification }>(),
  },
});
